/**
 * Version affichée dans l'interface. À incrémenter à chaque livraison (V2.1 → V2.2 …).
 * __BUILD_TIME__ = heure de démarrage du serveur (npm run dev) ou du build : permet de vérifier qu'on voit bien le dernier code.
 */
export const VERSION = 'V2.5';

export const NOTES_VERSION: Record<string, string[]> = {
  'V2.5': [
    "Assuré : import de la liste des biens depuis son dépôt de plainte (PDF ou photo, jusqu'à 6 pages) — biens cochables, doublons repérés",
    "Assuré : réimport possible plus tard (« Importer les biens de ma plainte ») et envoi d'une page complémentaire",
  ],
  'V2.4': [
    'Liste des experts : filtres spécialité, disponibilité, sans agenda, non localisé, proximité d\'un lieu (rayon, tri par distance), pagination',
    'Affectation : temps de route calculés pour les 49 bases les plus proches (au lieu des 49 premières) — tient à 350 experts',
  ],
  'V2.3': [
    'Compte Administrateur (identifiant admin) : espace Administration = équipe, rôles, invitations, vétusté par défaut du cabinet',
    "Assistanat : accès à TOUS les experts — fiche tournée (base, spécialités, RDV/jour, disponible) et agenda modifiables",
  ],
  'V2.2': [
    "Paramètres suivent l'espace affiché (Assistant / Expert), y compris pour un administrateur qui bascule",
    'Espace Assistant : profil (prénom, nom, téléphone) + tableau « Experts et tournées » (base, spécialités, RDV/jour, disponible)',
  ],
  'V2.1': [
    'Vétusté : le mode du contrat prime (lu dans les CG, modifiable dans Contrats) ; Paramètres = valeur par défaut',
    'Groupama HABI 01 : vétusté calculée au jour près',
    'Paramètres : profil terrain, sources de prix et disponibilités réservés aux experts',
  ],
  'V2.0': ['Parcours UPDATE1 : espace assistant, qualification, affectation, signature, dépôt de plainte, rappel de dossier'],
};

export const DATE_BUILD = (() => {
  try {
    return new Date(__BUILD_TIME__).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' });
  } catch {
    return '';
  }
})();
